import { Injectable, inject } from '@angular/core';
import {
  Firestore,
  collection,
  collectionData,
  doc,
  docData,
  query,
  where
} from '@angular/fire/firestore';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private firestore = inject(Firestore);

  private _user$: BehaviorSubject<User> = new BehaviorSubject({} as User);
  private _userHome$: BehaviorSubject<User> = new BehaviorSubject({} as User);

  setUser(user: User) {
    console.log('UserService.setUser llamado con:', user);
    this._user$.next(user);
    this._userHome$.next(user);
    console.log('UserService.setUser completado');
  }

  get user$() {
    return this._user$.asObservable();
  }

  get userHome$() {
    return this._userHome$.asObservable();
  }

  getAllStudent(): Observable<User[]> {
    const usersRef = collection(this.firestore, 'users');
    const q = query(usersRef, where('role', '==', 'estudiante'));
    return collectionData(q, { idField: 'id' }) as Observable<User[]>;
  }

  getUserById(id: string): Observable<User | undefined> {
    const userDocRef = doc(this.firestore, `users/${id}`);
    return docData(userDocRef, { idField: 'id' }) as Observable<User | undefined>;
  }
}
